<template>
  <div ref="loadOnScrollEl" v-if="isPagingTypeScroll">

  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "LotListLoadOnScroll",
  computed: {
    ...mapState(['lotQueryParams', 'lots']),
    ...mapGetters(['isPagingTypeScroll'])
  },
  methods: {
    ...mapActions(['getLots']),
    ...mapMutations(['setLotFilters', 'setPreserveOldLots']),
    async loadLots() {
      if (this.lots.totalRows > this.lots.results.length) {
        this.$emit('startFetchingLots');
        this.setLotFilters({page: parseInt(this.lotQueryParams.page) + 1});
        await this.getLots({stopLoading: true});
        this.$emit('stopFetchingLots');
      }
    }
  },
  mounted() {
    this.setPreserveOldLots(true);

    if (this.$refs.loadOnScrollEl) {
      const observer = new IntersectionObserver(
        (entries) => entries.forEach(entry => entry.isIntersecting && this.loadLots()), {
          rootMargin: '-250px 0px 0px 0px'
        })

      observer.observe(this.$refs.loadOnScrollEl)
    }
  },
  destroyed() {
    this.setPreserveOldLots(false);
  }
}
</script>

<style scoped>

</style>
